$(document).ready((function(){
    if ( $('#articles-tab').hasClass('active') ) {
        $("#articles-tab").click();
    }else{
        $("#product-tab").click();
    }
}));
//# sourceMappingURL=featureCardsPLP.js.map

// Script to retain filters on PLP
$(document).ready(function() {
    $('.refinement-option-button, .sidebarClearButton').on('click', function(event) {
        setTimeout(function() {
            var redirectHref = event.currentTarget.dataset.href.split('?')[1];
            var currentUrl = window.location.href.split('?')[0];
            var filterRetainingUrl = currentUrl + '?' +redirectHref;
            history.pushState(null, '', filterRetainingUrl);
        }, 100);
    });
});
window.addEventListener('popstate', function () {
    console.log('POPSTATE FIRED:', window.location.href);

    var ajaxUrl =
        '/on/demandware.store/Sites-medicalert-Site/default/Search-ShowAjax' +
        window.location.search;

    console.log('AJAX URL:', ajaxUrl);

    $.spinner().start();

    $.ajax({
        url: ajaxUrl,
        method: 'GET',

        success: function (response) {
            var $results = $(response);

            // 1. Update product grid
            $('.product-grid').html(
                $results.find('.product-grid').html()
            );

            // 2. Update main refinement/filter section
            $('.refinements').html(
                $results.find('.refinements').html()
            );

            // 3. Update mobile filter bar
            $('.filter-bar').html(
                $results.find('.filter-bar').html()
            );

            // 4. During Back/Forward, restore the filter state/chips,
            // but don't show the filter option dropdown/scroll section.
            $('.refinements .filter-options').addClass('d-none');

            // 5. Don't leave any filter button visually active/open
            $('.refinements .filter-button').removeClass('btn-focus');
        },

        error: function (xhr) {
            console.error(
                'Search-ShowAjax request failed:',
                xhr.status,
                xhr.responseText
            );
        },

        complete: function () {
            $.spinner().stop();
        }
    });
});